import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import base from './modules/base'
import account from './modules/account'
import notice from './modules/notice'

import {getAllDicts} from '@/http/api'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {base, account, notice},
  state: {
    deadline1: '', // 报名 填写:基本信息、参会信息、餐饮信息  允许删除、新增、修改
    deadline2: '', // 报名截止 报名修改 不可新增报名，可修改、删除报名信息 允许修改、删除：基本信息、参会信息、餐饮信息
    deadline3: '', // 锁定基本信息、参会信息、餐饮信息，不能修改、删除
    deadline4: '', // 接驳信息填写权限
    deadline5: '', // 锁定信息不能修改、删除
    clientRelationships: [],
    guestsType: [],
    name: [],
    transport: [],
    site: [],
    touristRoutes: [],
    vestSize: [],
    sjzj: [],
    showRuleFlag: true, // 时光印迹 控制活动规则进入展示
    showBeautifyFlag: true, // 时光印迹 美化打印提示
    showApplyTipsFlag: true // 首页 报名提醒 展示
  },
  getters: {},
  mutations: {
    SET_DEADLINE1: (state, data) => {
      state.deadline1 = data
    },
    SET_DEADLINE2: (state, data) => {
      state.deadline2 = data
    },
    SET_DEADLINE3: (state, data) => {
      state.deadline3 = data
    },
    SET_DEADLINE4: (state, data) => {
      state.deadline4 = data
    },
    SET_DEADLINE5: (state, data) => {
      state.deadline5 = data
    },
    SET_CRS: (state, data) => {
      state.clientRelationships = [...data]
    },
    SET_GT: (state, data) => {
      state.guestsType = [...data]
    },
    SET_NAME: (state, data) => {
      state.name = [...data]
    },
    SET_SITE: (state, data) => {
      state.site = [...data]
    },
    SET_TSP: (state, data) => {
      state.transport = [...data]
    },
    SET_TR: (state, data) => {
      state.touristRoutes = [...data]
    },
    SET_VS: (state, data) => {
      state.vestSize = [...data]
    },
    SET_SGZJ: (state, data) => {
      state.sjzj = [...data]
    },
    SET_SHOWRULEFLAG: (state, data) => {
      state.showRuleFlag = data
    },
    SET_SHOWBEAUTIFYFLAG: (state, data) => {
      state.showBeautifyFlag = data
    },
    SET_SHOWAPPLYTIPSFLAG: (state, data) => {
      state.showApplyTipsFlag = data
    }
  },
  actions: {
    getAllDicts({commit}) {
      return new Promise(resolve => {
        getAllDicts().then(res => {
          let deadline1 = res.data.annual_meeting_notice.find(item => item.dictKey === 1)?.dictValue
          let deadline2 = res.data.annual_meeting_notice.find(item => item.dictKey === 2)?.dictValue
          let deadline3 = res.data.annual_meeting_notice.find(item => item.dictKey === 3)?.dictValue
          let deadline4 = res.data.annual_meeting_notice.find(item => item.dictKey === 4)?.dictValue
          let deadline5 = res.data.annual_meeting_notice.find(item => item.dictKey === 5)?.dictValue
          commit('SET_DEADLINE1', deadline1)
          commit('SET_DEADLINE2', deadline2)
          commit('SET_DEADLINE3', deadline3)
          commit('SET_DEADLINE4', deadline4)
          commit('SET_DEADLINE5', deadline5)
          commit('SET_CRS', res.data.annual_meeting_client_relationships)
          commit('SET_GT', res.data.annual_meeting_guests_type)
          commit('SET_NAME', res.data.annual_meeting_nane)
          commit('SET_TSP', res.data.annual_meeting_transport)
          // commit('SET_SITE', res.data.annual_meeting_site)
          commit('SET_SITE', res.data.annual_meeting_arrival_place)
          commit('SET_TR', res.data.annual_meeting_tourist_routes)
          commit('SET_VS', res.data.annual_meeting_vest_size || [])
          commit('SET_SGZJ', res.data.sgzj || [])
          resolve()
        })
      })
    }
  },
  plugins: [
    createPersistedState({
      // storage: window.sessionStorage,
      reducer(value) {
        // console.log(value)
        return {
          deadline: value.deadline,
          clientRelationships: value.clientRelationships,
          guestsType: value.guestsType,
          name: value.name,
          transport: value.transport,
          site: value.site,
          touristRoutes: value.touristRoutes,
          vestSize: value.vestSize,
          sgzj: value.sgzj,
          account: value.account,
          base: value.base,
          notice: value.notice,
          showRuleFlag: value.showRuleFlag,
          showBeautifyFlag: value.showBeautifyFlag,
          showApplyTipsFlag: value.showApplyTipsFlag,
        }
      }
    })
  ]
})
